import api from "../Api";
import routes from "../constants/ApiRoutesConstants";

export default async function GetStatusList() {
  const res = await api.get(routes.GET_STATUS_LIST);

  return res;
}
